<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useVirtualKeyboard } from '@/composables/keyboard'

const { vkeyboard, keyboardType, canAutoHideOnEnter } = useVirtualKeyboard();

const props = defineProps({
  id: {
    type: String,
    default: null
  },
  name: {
    type: String,
    default: null
  },
  type: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: ""
  },
  enabled: {
    type: Boolean,
    default: true
  },
  required: {
    type: Boolean,
    default: false
  },
  readonly: {
    type: Boolean,
    default: false
  },
  validation: {
    type: String,
    default: null
  },
  rows: {
    type: String,
    default: null
  },
  modelValue: {
  }
});

const emit = defineEmits([ "update:modelValue", "change", "enter" ]);

const focus = (e) => { };
const unfocus = (e) => { };
defineExpose({ focus, unfocus });

const isFocused = ref(false);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
    emit('change', value);
  }
});

onMounted(() => {
  vkeyboard.on("target change", onTargetChange); //Keyboard focus
});

onUnmounted(() => {
  vkeyboard.removeListener("target change", onTargetChange); //Keyboard unfocus
});

function onTargetChange(target) {
  if (target == this.target) {
    vkeyboard.removeAllListeners("enter");
    vkeyboard.on("enter", onEnterKey);
    canAutoHideOnEnter.value = false;
    isFocused.value = true;
  }
  else {
    vkeyboard.removeListener("enter", onEnterKey);
    canAutoHideOnEnter.value = true;
    isFocused.value = false;
  }
}

function onFocus(e) {
  if (props.enabled && !props.readonly) {
    keyboardType.value = props.type == "numeric" ? "numeric" : "default";
    focus(e);
    vkeyboard.show(e.target);
  }
}

function onUnfocus(e) {
  if (props.enabled && !props.readonly) {
    unfocus(e);
    vkeyboard.hide(e.target, { delay: 120 }); //Give other input a chance to cancel hide within 30ms
  }
}

function onEnterKey() {
  //emit("enter");
  console.log("ENTER: TextArea add new line")
  value.value += "\n"; //Add new line
}
</script>

<template>
  <textarea :id="props.id" v-model="value" :placeholder="props.placeholder"
    :required="!!props.required" :readonly="!!props.readonly" :disabled="!props.enabled"
    role="presentation" :rows="props.rows"
    class="textarea" :class="[ { 'textarea-focus': isFocused, 'textarea-error': !!props.validation }, $attrs.class ]"
    @focus="onFocus" @blur="onUnfocus"></textarea>
    <!-- @keypress.enter="onEnterKey" -->
  <div class="textbox-validation-message" :class="$attrs.class" v-if="!!props.validation">
    {{ typeof validation == "string" ? validation : validation.message }}
  </div>
</template>

<style scoped>
.textarea {
  @apply bg-white border border-gray-300 text-gray-900 text-sm rounded-lg
    focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5
    dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
    dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500;
}

.textbox:disabled {
  @apply text-gray-400;
}

/*
.textarea.textarea-focus {
  @apply ring-blue-500 border-blue-500 dark:ring-blue-500 dark:border-blue-500;
}
*/

.textarea.textarea-error {
  @apply border-red-700 bg-red-100 text-red-900 focus:ring-red-500 focus:border-red-500;
}

.textarea:focus,
.textarea.focus-for-keyboard {
  @apply ring-blue-500 border-blue-500;

  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty, );
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #1C64F2;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #1C64F2;
}
</style>